import React, { CSSProperties, Suspense, lazy } from 'react';
import { classNameForElement, StyleElem, styleForElement } from './Toast.style';
import IconExclamation from '@monofe/ui-common/icon/IconExclamation';
import IconQuestionMark from '@monofe/ui-common/icon/IconQuestionMark';
import IconTick from '@monofe/ui-common/icon/IconTick';
import IconInfo from '@monofe/ui-common/icon/IconInfo';

export enum IToastIcon {
    Undef = 0,
    Information = 1,
    Success = 2,
    Warning = 3,
    Error = 4,
    LastValue = 5,
}

export interface IToastProps {
    text: string;
    icon: IToastIcon;
    style?: CSSProperties;
}

function Toast(props: IToastProps): JSX.Element {
    const style = (elem: StyleElem) => styleForElement(elem, props);
    const className = (elem: StyleElem) => classNameForElement(elem, props);

    return (
        <div
            role="alert"
            aria-live={props.icon === IToastIcon.Error ? 'assertive' : 'polite'}
            className={className(StyleElem.Container)}
            style={style(StyleElem.Container)}
        >
            {props.icon === IToastIcon.Error && (
                <Suspense fallback={<span></span>}>
                    <IconExclamation
                        className={className(StyleElem.Icon)}
                        style={style(StyleElem.Icon)}
                    />
                </Suspense>
            )}
            {props.icon === IToastIcon.Success && (
                <Suspense fallback={<span></span>}>
                    <IconTick className={className(StyleElem.Icon)} style={style(StyleElem.Icon)} />
                </Suspense>
            )}
            {props.icon === IToastIcon.Warning && (
                <Suspense fallback={<span></span>}>
                    <IconQuestionMark
                        className={className(StyleElem.Icon)}
                        style={style(StyleElem.Icon)}
                    />
                </Suspense>
            )}
            {props.icon === IToastIcon.Information && (
                <Suspense fallback={<span></span>}>
                    <IconInfo className={className(StyleElem.Icon)} style={style(StyleElem.Icon)} />
                </Suspense>
            )}
            <span className={className(StyleElem.Text)} style={style(StyleElem.Text)}>
                {props.text}
            </span>
        </div>
    );
}

export default Toast;
